// src/components/common/AddressText.tsx
// Превращает адреса (URL, www-домены, e-mail) в тексте в кликабельные
// синие ссылки с подчёркиванием. Используется на публичных страницах
// (реквизиты, результат) для адресов поддержки и оферты.
import React from 'react';
import styled from 'styled-components';

const AddressLink = styled.a`
  color: #2563eb;
  text-decoration: underline;
`;

const ADDRESS_RE = /((?:https?:\/\/|www\.)[^\s]+|[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g;

const addressHref = (address: string): string => {
  if (address.includes('@')) return `mailto:${address}`;
  if (address.startsWith('http')) return address;
  return `https://${address}`;
};

const AddressText: React.FC<{ text: string }> = ({ text }) => {
  const parts = text.split(ADDRESS_RE);
  return (
    <>
      {parts.map((part, i) => {
        if (i % 2 === 0) return part;
        const href = addressHref(part);
        const external = !href.startsWith('mailto:');
        return (
          <AddressLink
            key={i}
            href={href}
            target={external ? '_blank' : undefined}
            rel={external ? 'noopener noreferrer' : undefined}
          >
            {part}
          </AddressLink>
        );
      })}
    </>
  );
};

export default AddressText;